import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Check, Users } from "lucide-react";
import api from "@/lib/api";
import ShareCard from "@/components/ShareCard";

export default function Referrals() {
    const [data, setData] = useState(null);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        api.get("/referrals/me").then((r) => setData(r.data)).catch(() => {});
    }, []);

    const copy = async () => {
        if (!data?.code) return;
        try {
            const url = `${window.location.origin}/?ref=${data.code}`;
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 1600);
        } catch {
            toast.error("couldn't copy — try selecting manually");
        }
    };

    if (!data) {
        return (
            <div className="max-w-2xl mx-auto pt-10 text-inkSoft font-body">loading…</div>
        );
    }

    return (
        <div className="max-w-2xl mx-auto pt-4">
                <p className="text-xs uppercase tracking-[0.3em] text-inkSoft mb-3 font-body">tell a friend</p>
                <h1 className="font-heading text-4xl md:text-5xl tracking-tight text-ink mb-2">
                    share pax with someone who needs it.
                </h1>
                <p className="text-inkSoft font-body mb-10 max-w-lg">
                    know someone who could use a companion? send them your link. we'll let you know when they join.
                </p>

                <div className="bg-white/70 border border-clayHover rounded-3xl p-6 md:p-8 mb-6" data-testid="referral-card">
                    <p className="text-xs uppercase tracking-widest text-inkSoft mb-2 font-body">your invite link</p>
                    <div className="flex items-center gap-3">
                        <code className="flex-1 bg-clay/60 rounded-2xl px-4 py-3 text-ink font-mono text-sm truncate" data-testid="referral-link">
                            {`${window.location.origin}/?ref=${data.code}`}
                        </code>
                        <button
                            onClick={copy}
                            data-testid="referral-copy"
                            className="bg-terracotta text-bone px-5 py-3 rounded-full hover:bg-terracottaHover transition-colors font-body text-sm flex items-center gap-2"
                        >
                            {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
                            {copied ? "copied" : "copy"}
                        </button>
                    </div>

                    <div className="mt-8 flex items-center gap-2 text-sm font-body text-inkSoft" data-testid="referral-count">
                        <Users className="w-4 h-4" /> {data.referrals} {data.referrals === 1 ? "friend has" : "friends have"} joined through your link
                    </div>
                </div>

                <ShareCard />
            </div>
    );
}
